export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`);
  if (element) {
    return element.getAttribute("content");
  }
}

export function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root;
    root = document;
  }
  return root.querySelector(selector);
}

export function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

export const parseNestedKey = (key) => {
  // Match the base object and its nested attributes
  const matches = key.match(/^([^\[]+)(\[.*\])$/);

  if (!matches) {
    return { [key]: null };
  }

  const [, base, attributesStr] = matches;

  // Extract all the attribute keys
  const attributeKeys = attributesStr
    .match(/\[([^\]]*)\]/g)
    .map((attr) => attr.replace(/^\[|\]$/g, ""));

  // Create the nested object structure
  const result = {};
  let current = result;

  current[base] = {};
  current = current[base];

  for (let i = 0; i < attributeKeys.length - 1; i++) {
    current[attributeKeys[i]] = {};
    current = current[attributeKeys[i]];
  }

  current[attributeKeys[attributeKeys.length - 1]] = null;

  return result;
};

export const objectToNestedKey = (obj, prefix = "") => {
  const keys = [];

  Object.entries(obj).forEach(([key, value]) => {
    if (value !== null && typeof value === "object") {
      const nestedKeys = objectToNestedKey(
        value,
        prefix ? `${prefix}[${key}]` : key,
      );
      keys.push(...nestedKeys);
    } else {
      keys.push(prefix ? `${prefix}[${key}]` : key);
    }
  });

  return keys;
};
